import { get, post, put, Delete } from "../axios";

// 账号审核-列表
export const memberExamineList = (params) =>
  get("/web/member/examine/list", params);

// 账号审核-状态修改
export const memberExamineStateUpdate = (params) =>
  put("/web/member/examine/state/update", params);
